import Link from "next/link";
import Image from "@/components/image";

export default function Background({ fields, first = false, sys, includes }) {
  const titleParts = fields.title && fields.title.split(" ");
  const last = titleParts.pop();
  const Title = ({ children }) => {
    return first ? (
      <h1 className="text-center text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
        {children}
      </h1>
    ) : (
      <h3 className="text-center text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
        {children}
      </h3>
    );
  };
  return (
    <section className="bg-white py-12">
      <div className="relative">
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gray-100"></div>
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <div className="relative shadow-xl sm:rounded-2xl sm:overflow-hidden">
            <div className="absolute inset-0">
              {fields.image && (
                <Image
                  fill
                  fields={fields.image}
                  className="h-full w-full object-cover"
                  alt={fields.title}
                />
              )}
              <div
                className="absolute inset-0 bg-gray-400"
                style={{ mixBlendMode: "multiply" }}
              ></div>
            </div>
            <div className="relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8">
              {fields.title && (
                <Title>
                  <span className="block text-white">
                    {titleParts.join(" ")}
                  </span>
                  {last && (
                    <span className="block text-brand-600"> {last}</span>
                  )}
                </Title>
              )}
              {fields.text && (
                <p className="mt-6 max-w-lg mx-auto text-center text-xl text-white sm:max-w-3xl">
                  {fields.text}
                </p>
              )}
              <div className="mt-10 max-w-sm mx-auto sm:max-w-none sm:flex sm:justify-center">
                <div className="space-y-4 sm:space-y-0 sm:mx-auto sm:inline-grid sm:grid-cols-2 sm:gap-5">
                  {fields.actions &&
                    fields.actions.map((action, index) => (
                      <Link
                        href={action.fields.link}
                        key={`i-${index}`}
                        className={`flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm  sm:px-8 ${
                          index === 0
                            ? "text-white bg-brand-500 bg-opacity-60 hover:bg-opacity-70"
                            : "text-brand-700 bg-white hover:bg-brand-50"
                        }`}
                      >
                        {action.fields.text}
                      </Link>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
